<template>
  <b-modal
    id="confirm-subscribe-modal"
    hide-footer
    hide-header
    centered
  >
    <div class="py-1">
      <div class="flex mb-1 justify-center">
        <b-img
          src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
          alt=""
        /></div>
      <div class="text-3xl font-semibold text-center text-black">
        Konfirmasi Berlangganan
      </div>
      <div class="text-center mb-2 mt-1">
        <span class="text-center">
          Aktifkan <span class="font-semibold">{{ packageName }}</span> 30 hari <span class="font-semibold">seharga Rp{{ IDRWithoutLbl(packagePrice) }}</span> pakai KomPay. Pastikan saldo KomPay kamu cukup, ya!
        </span>
      </div>
      <div class="p-1 mb-[5px] border rounded-md">
        <div class="text-[#333333] text-lg">
          Saldo Kompay
        </div>
        <div class="text-3xl mt-[8px] font-semibold  text-black">
          Rp{{ IDRWithoutLbl(saldo_kompay) }}
        </div>
      </div>
      <span
        v-show="!qualifyIdealBalance()"
        class="font-poppins mb-1 font-normal text-xs leading-tight tracking-normal"
      >
        <b-icon
          class="text-primary"
          icon="exclamation-triangle"
        /> Nominal saldo kompay kurang, Silahkan <b-link
          to="/keuangan/saldo"
          class="text-[#08A0F7] underline"
        >topup saldo kompaymu</b-link>
      </span>
      <!-- <b-form @submit.prevent="handleTopup"> -->
      <div
        v-show="isKomshipUser && !qualifyIdealBalance() && idealBalance.ideal_balance !== 0"
        class=" bg-[#FFEDED] rounded-lg mt-2 mb-1 p-1"
      >
        <div>
          <span class="font-poppins text-[14px] font-medium leading-[1] align-middle">
            <b-icon
              icon="exclamation-circle"
              class="text-danger mr-[5px]"
            />
            Batas Minimal Saldo Ideal : <span class="text-[15px] font-semibold leading-[1] align-middle">{{ IDRWithoutLbl(idealBalance.ideal_balance) }}</span>
          </span>
        </div>
        <div class="mb-[5px]">
          <span class="text-[12px] font-normal leading-[1] align-middle">
            Saldo ideal diterapkan untuk menghindari saldo minus. <a href="">Pelajari lebih lanjut</a>
          </span>
        </div>
        <div class="bg-white rounded-lg p-[8px]">
          <span class="text-[12px] mb-[6px] font-normal leading-[1] align-middle">
            <b-icon
              class="mr-[2px]"
              icon="chat-left-quote"
            /> Darimana Saldo Ideal berasal?
          </span>
          <div class="mt-[5px]">
            <span class="font-poppins text-[12px] font-normal leading-[1] align-middle">
              Potensi Pendapatan Order Dikirim <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.income_order_potential) }}</span> - Ongkir Retur Ketika Sampai <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ongkir_retur_on_finished) }}</span> - Resiko Ongkir Menjadi Retur <span class="font-poppins text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ongkir_risk_become_retur) }}</span> = Saldo Ideal <span class="font-poppins text-danger text-[12px] font-bold leading-[1] align-middle">Rp{{ IDRWithoutLbl(idealBalance.ideal_balance) }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="flex mt-2 items-center gap-2">
        <div class="w-full">
          <b-button
            block
            class="!h-[38px]"
            variant="outline-primary"
            @click="handleCancel"
          >
            Batal
          </b-button>
        </div>
        <div class="w-full">
          <b-button
            block
            variant="primary"
            type="button"
            :disabled="isLoading || !qualifyIdealBalance()"
            @click="handleConfirmSubscribe"
          >
            <div class="flex justify-center gap-1 items-center">
              <div>{{ isLoading ? 'Loading...' : cta }}</div>
            </div>
          </b-button>
        </div>
      </div>
      <!-- </b-form> -->
    </div>
  </b-modal>
</template>

<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { capitalizeWords } from '../../customer/Broadcast/config'
import { apiIdealBalance } from '../../customer/Broadcast/service/api.balance.service'

export default {
  props: {
    packageName: {
      type: String,
      default: 'Komchat Pro',
      // required: true,
    },
    packagePrice: {
      type: Number,
      default: 0,
      // required: true,
    },
    cta: {
      type: String,
      default: 'Bayar Sekarang',
      // required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saldo_kompay: this.$store.state.saldo.saldo,
      partnerId: this.$store.state.dashboard.profile.partner_id,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      IDRWithoutLbl,
      capitalizeWords,
      idealBalance: {},
    }
  },
  mounted() {
    if (this.isKomshipUser) {
      this.getIdealBalance()
    }
  },
  methods: {
    handleConfirmSubscribe() {
      this.$emit('confirm-subscribe', this.qualifyIdealBalance())
    },
    handleCancel() {
      this.$bvModal.hide('confirm-subscribe-modal')
    },

    async getIdealBalance() {
      try {
        const { data } = await apiIdealBalance(this.partnerId)
        this.idealBalance = data.data
      } catch (error) {
        this.$toast_error({ message: 'Gagal mendapatkan saldo ideal' })
      }
    },
    qualifyIdealBalance() {
      if (!this.isKomshipUser) {
        return this.saldo_kompay >= this.packagePrice
      }
      const remainingBalance = this.saldo_kompay - this.packagePrice
      return remainingBalance >= this.idealBalance.ideal_balance
    },
  },
}
</script>
